import { Link } from "react-router-dom";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";

export default function Privacy() {
  return (
    <>
      <Nav />
      <main
        data-testid="privacy-page"
        className="mx-auto max-w-3xl px-6 py-14 sm:py-20"
      >
        <Link
          to="/"
          className="text-sm text-muted-foreground transition-colors hover:text-foreground"
        >
          ← Back
        </Link>
        <h1 className="font-serif-display mt-6 text-5xl">Privacy</h1>
        <p className="mt-3 text-sm text-muted-foreground">
          Last updated: February 2026
        </p>

        <section className="mt-10 space-y-6 text-[15px] leading-7 text-foreground/90">
          <p>
            Call God is built on one simple promise: <em>what you say here is yours</em>.
            We collect as little as possible, and we never store raw audio of your
            conversations by default.
          </p>

          <div className="cg-card rounded-2xl p-6">
            <h2 className="font-serif-display text-2xl">What we don’t do</h2>
            <ul className="mt-3 list-disc space-y-2 pl-5 text-foreground/90">
              <li>We don’t store raw audio of your conversations.</li>
              <li>We don’t require signup, email, or a phone number to try the call.</li>
              <li>We don’t sell your data. Ever.</li>
              <li>We don’t profile you for advertising.</li>
            </ul>
          </div>

          <div className="cg-card rounded-2xl p-6">
            <h2 className="font-serif-display text-2xl">What we may keep, briefly</h2>
            <p className="mt-3">
              To keep the service healthy, we retain anonymous operational metadata
              (call duration, anonymised error reports, model latency) for up to
              <strong> 30 days</strong>. Aggregated, non-identifying analytics may be
              retained up to <strong>90 days</strong>. None of this is tied to your identity.
            </p>
          </div>

          <div className="cg-card rounded-2xl p-6">
            <h2 className="font-serif-display text-2xl">Anonymous mode</h2>
            <p className="mt-3">
              The default mode is anonymous. You may opt-in to save a written
              reflection at the end of a call. Saved reflections are stored only
              if you explicitly choose to save them, and you can delete them at
              any time.
            </p>
          </div>

          <div className="cg-card rounded-2xl p-6">
            <h2 className="font-serif-display text-2xl">Transcripts</h2>
            <p className="mt-3">
              Transcripts are opt-in. They are never created unless you ask for one.
            </p>
          </div>

          <div className="cg-card rounded-2xl p-6">
            <h2 className="font-serif-display text-2xl">Disclosure</h2>
            <p className="mt-3">
              The voice on the line is an AI. It is not literal divine authority, not
              a therapist, not a member of clergy, and not a substitute for emergency
              services. See our <Link to="/terms" className="underline">terms</Link>.
            </p>
          </div>

          <p className="text-sm text-muted-foreground">
            Questions about privacy: write to us at hello@callgod.org.
          </p>
        </section>
      </main>
      <Footer />
    </>
  );
}
